import React from 'react';
import ReactDOM from 'react-dom/client';
import { TiaGPCWebComponent } from './components/WebComponentWrapper';
import './styles/index.css';
import './styles/widget.css';
import './styles/responsive.css';
import { WIDGET_POSITIONS, THEMES, LANGUAGES, WIDGET_SIZES, SIZE_DIMENSIONS } from './utils/constants';
import { WIDGET_VERSION } from './config/security';

/**
 * API Global para inicialización programática
 */
window.TiaGPC = {
  version: WIDGET_VERSION,

  POSITIONS: WIDGET_POSITIONS,
  THEMES: THEMES,
  LANGUAGES: LANGUAGES,
  SIZES: WIDGET_SIZES,
  SIZE_DIMENSIONS: SIZE_DIMENSIONS,

  create(config) {
    if (!config || !config.token) {
      throw new Error('TiaGPC.create(): El parámetro "token" es requerido');
    }

    const widget = document.createElement('tia-gpc-widget');

    widget.setAttribute('token', config.token);

    if (config.theme) widget.setAttribute('theme', config.theme);
    if (config.position) widget.setAttribute('position', config.position);
    if (config.language) widget.setAttribute('language', config.language);
    if (config.primaryColor) widget.setAttribute('primary-color', config.primaryColor);
    if (config.size) widget.setAttribute('size', config.size);
    if (config.width) widget.setAttribute('width', config.width);
    if (config.height) widget.setAttribute('height', config.height);
    if (config.apiUrl) widget.setAttribute('api-url', config.apiUrl);
    if (config.autoOpen !== undefined) widget.setAttribute('auto-open', String(config.autoOpen));
    if (config.showBranding !== undefined) widget.setAttribute('show-branding', String(config.showBranding));
    if (config.mobileFullscreen !== undefined) widget.setAttribute('mobile-fullscreen', String(config.mobileFullscreen));

    if (config.onReady) {
      widget.addEventListener('ready', config.onReady);
    }
    if (config.onError) {
      widget.addEventListener('error', (e) => config.onError(e.detail));
    }
    if (config.onClose) {
      widget.addEventListener('close', config.onClose);
    }

    const container = config.container || document.body;
    container.appendChild(widget);

    return widget;
  },

  /**
   * Información sobre el widget
   */
  info() {
    return {
      version: this.version,
      positions: this.POSITIONS,
      themes: this.THEMES,
      languages: this.LANGUAGES,
      sizes: this.SIZES,
      sizeDimensions: this.SIZE_DIMENSIONS
    };
  }
};



export { TiaGPCWebComponent };
export default window.TiaGPC;